import { render, staticRenderFns } from "./SocialSectionInstagram.vue?vue&type=template&id=55bb13ab"
import script from "./SocialSectionInstagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialSectionInstagram.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports